import React from 'react'

const Custominput = (props) => {
  const {type,name,classname,placeholder, value, onChange, onBlur, disabled } = props;
  return (
    <div>
      <input 
      type={type}
      name={name} 
      className={`form-cont ${classname}`}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      disabled={disabled}
      />
  </div>
  )
}

export default Custominput